import { useEffect, useState, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import invalidOrderDrugService from "../services/invalidOrderDrugService";
import { Modal } from "react-responsive-modal";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from "react-datepicker";
import moment from "moment";

const tablePropsInitOrderDrugDetails = {
    columns: [
        { key: "rxf_number", title: "RX Number" },
        { key: "fac_group", title: "Facility Group" },
        { key: "ord_drug_name", title: "Interface Drug" },
        { key: "rxf_ord_sig", title: "Interface SIG" },
        { key: "rx_drug_name", title: "Dispense Drug" },
        { key: "rxf_sig", title: "Dispense SIG" },
        { key: "validation_message", title: "Response" },
        { key: "actions", title: "Actions" },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "rxf_number",
    paging: {
        enabled: true,
        pageIndex: 0,
        pageSize: 10,
        pagesCount: 0,
        position: PagingPosition.Bottom,
    },
};

const BypassActionPopup = ({
    showBypassActionPopup,
    onClose,
    selectedRow,
    bypassActionFormData,
    onBypassChange,
    onNotesChange,
    onBypassSubmit,
    onProcessCompleteChange,
    isSubmitting
}) => {
    const [processComplete, setProcessComplete] = useState(false);

    // Check if form is valid for submission
    const isFormValid = bypassActionFormData.is_bypassed !== null &&  // Either Yes or No is selected
        bypassActionFormData.action_description?.trim() !== '';

    useEffect(() => {
        setProcessComplete(!!bypassActionFormData?.process_complete);
    }, [bypassActionFormData?.process_complete, showBypassActionPopup]);

    // Handle process complete checkbox change
    const handleProcessComplete = (e) => {
        const checked = e.target.checked;
        setProcessComplete(checked);
        onProcessCompleteChange(checked);
    };

    return (
        <Modal
            open={showBypassActionPopup}
            onClose={onClose}
            center
            styles={{
                modal: {
                    height: "600px", // Increased height to accommodate new fields
                    overflowY: "visible",
                    width: "650px"
                }
            }}
        >
            <div className="pt-6 px-8 pb-8">
                <h3 className="text-2xl leading-6 font-bold mb-4" id="mar-headline">
                    Drug Mismatch - Bypass Action
                </h3>

                <div className="bg-white mt-4 rounded">
                    <div className="mb-6">
                        <div className="mb-4 flex flex-row gap-5">
                            <span className="block text-sm font-medium text-gray-700">RX Number : </span>
                            <span className="text-gray-900">{selectedRow?.rxf_number || 'N/A'}</span>
                        </div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Bypassed</label>
                        <div className="flex items-center space-x-6 mb-4">
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-indigo-600"
                                    checked={bypassActionFormData.is_bypassed === true}
                                    onChange={() => onBypassChange(true)}
                                />
                                <span className="ml-2">Yes</span>
                            </label>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-indigo-600"
                                    checked={bypassActionFormData.is_bypassed === false}
                                    onChange={() => onBypassChange(false)}
                                />
                                <span className="ml-2">No</span>
                            </label>
                        </div>

                        {bypassActionFormData.is_bypassed === false && (
                            <div className="mb-4">
                                <label className="inline-flex items-center">
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-4 w-4 text-indigo-600"
                                        checked={processComplete}
                                        onChange={handleProcessComplete}
                                    />
                                    <span className="ml-2 text-sm font-medium text-gray-700">PROCESS COMPLETE</span>
                                </label>
                            </div>
                        )}

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
                            <textarea
                                className="w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                                rows="8"
                                value={bypassActionFormData.action_description}
                                onChange={onNotesChange}
                                placeholder="Enter notes here..."
                            />
                        </div>

                        <div className="flex justify-end space-x-4 mt-6">
                            <button
                                type="button"
                                className="rounded font-medium h-8 px-6 mt-2 sm:mt-5 text-white w-auto bg-grey bg-login_btn focus:outline-none"
                                onClick={onClose}
                            >
                                Cancel
                            </button>

                            {bypassActionFormData.is_bypassed === false && !processComplete ? (
                                <button
                                    type="button"
                                    className={
                                        (!isFormValid || isSubmitting)
                                            ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                            : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    }
                                    onClick={onBypassSubmit}
                                    disabled={!isFormValid || isSubmitting}
                                >
                                    {isSubmitting ? 'Saving...' : 'Save'}
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className={
                                        (!isFormValid || isSubmitting)
                                            ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                            : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    }
                                    onClick={onBypassSubmit}
                                    disabled={!isFormValid || isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const InvalidOrderDrugReport = ({ history }) => {

    const handleExport = async () => {
        try {
            setLoading(true);
            const filDateParam = fillDate ? fillDate : undefined;
            const filterParam = selectedFilter ? selectedFilter : undefined;
            const response = await invalidOrderDrugService.getInvalidOrderDrugs(totalPageCount, 1, filDateParam, filterParam); // Get all records with filters
            const data = Array.isArray(response?.response) ? response.response : [];
            handleDownloadPDF(data);
        } catch (err) {
            console.error('Error exporting data:', err);
            alert('Failed to export data. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const [loading, setLoading] = useState(false);
    const [tablePropsOrderDrugDetails, changeTablePropsOrderDrugDetails] = useState(tablePropsInitOrderDrugDetails);
    const [error, setError] = useState(null);
    const [showBypassActionPopup, setShowBypassActionPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [bypassActionFormData, setBypassActionFormData] = useState({
        is_bypassed: null,
        is_hide: null,
        action_description: '',
        "id": 0,
        process_complete: false,
    });
    const [fillDate, setFillDate] = useState(moment().format("MM/DD/YYYY"));
    const [filters, setFilters] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState();
    const loadFilters = async () => {
        try {
            const response = await invalidOrderDrugService.getInvalidOrderDrugDefaults();
            if (response?.ord_drg_filters) {
                setFilters(response.ord_drg_filters);
            }
        } catch (error) {
            console.error('Error loading filters:', error);
        }
    };

    useEffect(() => {
        loadFilters();
    }, []);
    const handleDownloadPDF = (data) => {
        // Create a new PDF document in landscape mode
        const doc = new jsPDF('l', 'pt');

        // Define table columns
        const columns = [
            { header: 'RX Number', dataKey: 'rxf_number' },
            { header: 'Interface Drug', dataKey: 'ord_drug_name' },
            { header: 'Interface SIG', dataKey: 'rxf_ord_sig' },
            { header: 'Dispense Drug', dataKey: 'rx_drug_name' },
            { header: 'Dispense SIG', dataKey: 'rxf_sig' },
            { header: 'Sorter Code', dataKey: 'fac_workflow_code' },
            { header: 'Facility Code', dataKey: 'fac_dcode' },
            { header: 'Response', dataKey: 'validation_message' }
        ];

        // Prepare data for the table
        const tableData = data.map(item => ({
            rxf_number: item.rxf_number || '',
            fac_workflow_code: item.fac_workflow_code || '',
            fac_dcode: item.fac_dcode || '',
            rx_drug_name: item.rx_drug_name || '',
            rxf_sig: item.rxf_sig || '',
            ord_drug_name: item.ord_drug_name || '',
            rxf_ord_sig: item.rxf_ord_sig || '',
            validation_message: item.validation_message || ''
        }));

        // Add title
        doc.setFontSize(16);
        doc.text('Drug Mismatch Report', 40, 40);
        doc.setFontSize(10);
        const metaParts = [`Generated on: ${new Date().toLocaleString()}`];
        if (selectedFilter) metaParts.push(` Filter: ${selectedFilter}`);
        if (fillDate) metaParts.push(` Fill Date: ${fillDate}`);
        doc.text(metaParts.join(' | '), 40, 60);

        // Set smaller font for table
        doc.setFontSize(8);

        // Add the table
        doc.autoTable({
            head: [columns.map(col => col.header)],
            body: tableData.map(row => columns.map(col => row[col.dataKey])),
            startY: 80,
            styles: {
                fontSize: 8,
                cellPadding: 3,
                overflow: 'linebreak',
                lineWidth: 0.5,
                lineColor: [0, 0, 0]
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold',
                fontSize: 9
            },
            alternateRowStyles: {
                fillColor: [245, 245, 245]
            },
            margin: { top: 80 }
        });

        // Save the PDF
        doc.save('DrugMismatchReport.pdf');
    };

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0
    });

    const fetchInvalidOrderDrugs = useCallback(async (newPageIndex = pagination.pageIndex, newPageSize = pagination.pageSize, fil_date = null, filter = null) => {
        try {
            setLoading(true);
            setError(null);
            const response = await invalidOrderDrugService.getInvalidOrderDrugs(newPageSize, newPageIndex + 1, fil_date || undefined, filter || undefined);

            if (!response) {
                throw new Error('No response from server');
            }

            const drugsData = Array.isArray(response.response) ? response.response : [];
            // Update table data using ka-table's updateData action
            dispatch(updateData(drugsData));
            setTotalPageCount(response.count || 0);

            // Update pagination (handle 0 as valid count)
            if (typeof response?.count === 'number') {
                const hasData = response.count > 0;
                const pagesCount = hasData ? Math.ceil(response.count / newPageSize) : 0;
                setPagination(prev => ({
                    ...prev,
                    pageIndex: hasData ? newPageIndex : 0,
                    totalCount: response.count,
                    pagesCount
                }));

                // Update table props with new pagination and toggle paging visibility
                changeTablePropsOrderDrugDetails(prev => ({
                    ...prev,
                    paging: {
                        ...prev.paging,
                        enabled: hasData,
                        pageIndex: hasData ? newPageIndex : 0,
                        pagesCount,
                        totalCount: response.count
                    }
                }));
            }
        } catch (err) {
            console.error('Error fetching invalid order drugs:', err);
            setError('Failed to load invalid order drugs. Please try again later.');
            dispatch(updateData([]));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {

    }, [fillDate]);

    useEffect(() => {
        // Only fetch if we have a valid page index and size
        if (pagination.pageIndex >= 0 && pagination.pageSize > 0) {
            const fetchData = async () => {
                const filDateParam = fillDate ? fillDate : undefined;
                const filterParam = selectedFilter ? selectedFilter : undefined;
                await fetchInvalidOrderDrugs(pagination.pageIndex, pagination.pageSize, filDateParam, filterParam);
            };
            fetchData();
        }
    }, [pagination.pageIndex, pagination.pageSize]);

    const dispatch = async (action) => {
        changeTablePropsOrderDrugDetails((prevState) => {
            const newState = kaReducer(prevState, action);

            // Handle page change
            if (action.type === ActionType.UpdatePageIndex) {
                const pageIndex = action.pageIndex;
                handlePageChange(pageIndex);
            }

            return newState;
        });
    };

    const CustomCellBypassAction = ({ rowData }) => {
        return (
            <div className="action_btns">
                <span className="inline-block mr-3 cursor-pointer">
                    <img
                        src="./img/edit_icon.svg"
                        className="m-auto w-4 h-4"
                        onClick={() => {
                            setSelectedRow(rowData);

                            const initialIsBypassed = typeof rowData?.is_resolved === 'boolean' ? rowData.is_resolved : null;
                            const initialNotes = rowData?.action_description || '';
                            const initialIsHide = typeof rowData?.is_hide === 'boolean' ? rowData.is_hide : (initialIsBypassed === true ? false : initialIsBypassed === false ? true : null);
                            const initialProcessComplete = initialIsHide === true; // if is_hide is true then process complete should be selected

                            setBypassActionFormData({
                                is_bypassed: initialIsBypassed,
                                is_hide: initialIsHide,
                                action_description: initialNotes,
                                id: rowData?.id || 0,
                                process_complete: initialProcessComplete,
                            });

                            setShowBypassActionPopup(true);
                        }}
                        alt="Edit"
                        title="Edit"
                    />
                </span>
            </div>
        );
    };

    const handlePageChange = (pageIndex) => {
        // Update pagination state which will trigger the useEffect
        setPagination(prev => ({
            ...prev,
            pageIndex: pageIndex
        }));
    };

    const handleBypassChange = (isBypassed) => {
        setBypassActionFormData(prev => ({ ...prev, is_bypassed: isBypassed, is_hide: isBypassed ? false : true }));
    };

    const handleNotesChange = (e) => {
        setBypassActionFormData(prev => ({ ...prev, action_description: e.target.value }));
    };

    const handleProcessCompleteChange = (checked) => {
        setBypassActionFormData(prev => ({ ...prev, process_complete: !!checked }));
    };


    const handleBypassActionSubmit = async () => {
        try {
            // derive final payload based on radio + process_complete following the rules:
            // - when Yes is selected: is_bypassed = true, is_hide = false
            // - when No is selected: is_bypassed = false, is_hide = true
            // - when No + Process complete selected: is_bypassed = true, is_hide = true
            const form = { ...bypassActionFormData }; // current state (may include process_complete)
            const processComplete = !!form.process_complete;

            let finalIsBypassed = form.is_bypassed;

            if (form.is_bypassed === true) {
                // Yes selected
                finalIsBypassed = true;
            } else if (form.is_bypassed === false) {
                // No selected
                if (processComplete) {
                    // No + Process complete => treat as bypassed but still hidden
                    finalIsBypassed = true;
                } else {
                    finalIsBypassed = false;
                }
            } else {
                // is_bypassed is null/undefined: prevent submit
                console.warn('Bypass action submit called with null is_bypassed');
                return;
            }

            // Remove is_hide from the spread basis
            const { process_complete, is_hide, ...restForm } = form;

            // Build payload conditionally
            const finalPayload = {
                ...restForm,
                is_bypassed: finalIsBypassed,
                ...(form.is_bypassed === false && processComplete ? { is_hide: true } : {})
            };

            await invalidOrderDrugService.postInvalidOrderDrugAction(finalPayload);
            const filDateParam = fillDate ? fillDate : undefined;
            const filterParam = selectedFilter ? selectedFilter : undefined;
            await fetchInvalidOrderDrugs(pagination.pageIndex, pagination.pageSize, filDateParam, filterParam);
            setLoading(true);
            setBypassActionFormData({
                is_bypassed: null,
                is_hide: null,
                action_description: '',
                "id": 0,
                process_complete: false
            });
            setShowBypassActionPopup(false);
        } catch (err) {
            console.error('Error saving data:', err);
            setError('Failed to save data. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = async (e) => {
        const newFilter = e.target.value;
        setSelectedFilter(newFilter);
        const filDateParam = fillDate ? fillDate : undefined;
        const filterParam = newFilter ? newFilter : undefined;
        await fetchInvalidOrderDrugs(0, 10, filDateParam, filterParam);
    };

    return (
        <>
            <CipHeader title="Drug Mismatch" />
            <div
                className={`flex justify-center items-center top-2/3 left-1/2  absolute ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000}
                />
            </div>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
                <div className="p-4 flex justify-between items-center">
                    <h2 className="text-lg font-medium">Drug Mismatch</h2>
                    <div className="flex items-center space-x-4">
                        <select
                            name="defaultFilters"
                            aria-label="Select Filter"
                            value={selectedFilter || ""}
                            onChange={handleFilterChange}
                            className="border focus:outline-none h-10 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                        >
                            <option value="">Select Filter</option>
                            {filters
                                ? filters.map((item, i) => (
                                    <option key={i} value={item}>
                                        {item}
                                    </option>
                                ))
                                : null}
                        </select>

                        {selectedFilter ? (
                            <button
                                type="button"
                                className="ml-2 text-xs text-gray-600 hover:text-gray-800 underline"
                                onClick={async () => {
                                    setSelectedFilter(undefined);
                                    const filDateParam = fillDate ? fillDate : undefined;
                                    await fetchInvalidOrderDrugs(0, 10, filDateParam, undefined);
                                }}
                                aria-label="Clear filter"
                                title="Clear filter"
                            >
                                Clear
                            </button>
                        ) : null}
                        <DatePicker
                            placeholderText="MM/DD/YYYY"
                            selected={fillDate ? moment(fillDate, "MM/DD/YYYY").toDate() : null}
                            isClearable
                            onChange={async (date) => {
                                const newDateStr = date ? moment(date).format("MM/DD/YYYY") : undefined;
                                setFillDate(newDateStr);
                                const filDateParam = newDateStr || undefined;
                                const filterParam = selectedFilter ? selectedFilter : undefined;
                                await fetchInvalidOrderDrugs(0, 10, filDateParam, filterParam);
                            }}
                            className="border focus:outline-none h-11 bg-header_bg text-white rounded-md px-3 font-normal text-sm w-40 custom-datepicker"
                        />
                        <button
                            type="button"
                            className="inline-flex items-center px-4 py-2.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white bg-login_btn hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 whitespace-nowrap"
                            onClick={() => handleExport('pdf')}
                        >
                            Download
                        </button>
                    </div>
                </div>
                <div className="p-2 text-xs patientDetails gridList overflow-x-auto">
                    <Table
                        className="table-fixed"
                        {...tablePropsOrderDrugDetails}
                        childComponents={{
                            dataRow: {
                                elementAttributes: ({ rowData }) => {
                                    const raw = rowData?.is_resolved;

                                    // treat explicit boolean false and numeric 0 as unresolved.
                                    // treat string 'false','0','no','n' (case/whitespace normalized) as unresolved.
                                    const isMissing = raw === null || raw === undefined;
                                    const normalized = typeof raw === 'string' ? raw.trim().toLowerCase() : String(raw);
                                    const isExplicitlyUnresolved =
                                        raw === false ||
                                        raw === 0 ||
                                        normalized === 'false' ||
                                        normalized === '0' ||
                                        normalized === 'no' ||
                                        normalized === 'n';

                                    // If you do NOT want to treat missing/null as unresolved, keep this:
                                    if (isMissing && !isExplicitlyUnresolved) {
                                        // Explicitly return an empty style/class so reused DOM nodes do not keep previous styles
                                        return { style: {} };
                                    }

                                    if (isExplicitlyUnresolved) {
                                        // Use inline style so it always overrides zebra or other CSS
                                        return {
                                            style: { backgroundColor: '#FEE2E2' }, // same color you suggested earlier
                                            // optionally keep className too if you need it for tests or selectors
                                            className: 'bg-mediRefused',
                                        };
                                    }

                                    // resolved / other: explicitly clear style/class to avoid DOM reuse artifacts
                                    return { style: {}, className: '' };
                                },
                            },
                            cellText: {
                                content: (props) => {
                                    if (props.column.key === "actions") {
                                        return <CustomCellBypassAction {...props} />;
                                    }
                                    return <span className="text-sm">{props.value}</span>;
                                },
                            },
                        }}
                        dispatch={dispatch}
                    />
                </div>
            </div>
            {showBypassActionPopup && (
                <BypassActionPopup
                    showBypassActionPopup={showBypassActionPopup}
                    onClose={() => {
                        setBypassActionFormData({
                            is_bypassed: null,
                            is_hide: null,
                            action_description: '',
                            "id": 0,
                            process_complete: false
                        });
                        setShowBypassActionPopup(false)
                    }}
                    selectedRow={selectedRow}
                    bypassActionFormData={bypassActionFormData}
                    onBypassChange={handleBypassChange}
                    onNotesChange={handleNotesChange}
                    onBypassSubmit={() => handleBypassActionSubmit()}
                    onProcessCompleteChange={(change) => handleProcessCompleteChange(change)}
                    isSubmitting={loading}
                />
            )}
        </>
    );

};

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(InvalidOrderDrugReport)
);